import { merge } from "ts-deepmerge";

import { AppHeaderTranslations } from "@/components/AppHeader/AppHeader.i18n";
import { ConflictResolutionModalTranslations } from "@/components/ConflictResolutionModal/ConflictResolitionModal.i18n";
import { DuplicateCurriculumModalTranslations } from "@/components/DuplicateCurriculumModal/DuplicateCurriculumModal.i18n";
import { EditCurriculumModalTranslations } from "@/components/EditCurriculumModal/EditCurriculumModal.i18n";
import { ExploreSchemeHeaderI18n } from "@/components/ExploreSchemeHeader/ExploreSchemeHeader.i18n";
import { ExploreSubjectUnitCardTranslations } from "@/components/ExploreSubjectUnitCard/ExploreSubjectUnitCard.i18n";
import { GenericCurriculumFormTranslations } from "@/components/GenericCurriculumModal/GenericCurriculumModal.i18n";
import { GenericErrorTranslations } from "@/components/GenericError/GenericError.i18n";
import { GenericErrorModalI18n } from "@/components/GenericErrorModal/GenericErrorModal.i18n";
import { ManageAdaptationNotesModalI18n } from "@/components/ManageAdaptationNotesModal/ManageAdaptationNotesModal.i18n";
import { MultiSchoolAccountModalI18n } from "@/components/MutilSchoolAccountModal/MultiSchoolAccountModal.i18n";
import { NewCurriculumModalTranslations } from "@/components/NewCurriculumModal/NewCurriculumModal.i18n";
import { NewUnitCardI18n } from "@/components/NewUnitCard/NewUnitCard.i18n";
import { PlannerSettingsModalTranslations } from "@/components/PlannerSettingsModal/PlannerSettingsModal.i18n";
import { RemoveUnitModalI18n } from "@/components/RemoveUnitModal/RemoveUnitModal.i18n";
import { SessionExpiredModalI18n } from "@/components/SessionExpiredModal/SessionExpiredModal.i18n";
import { SidebarNavigationTranslations } from "@/components/SidebarNav/SidebarNav.i18n";
import { SignedOutModalI18n } from "@/components/SignedOutModal/SignedOutModal.i18n";
import { SubjectCardTranslations } from "@/components/SubjectCard/SubjectCard.i18n";
import { SubjectPlanHeaderI18n } from "@/components/SubjectPlanHeader/SubjectPlanHeader.i18n";
import { TableUnitCardI18n } from "@/components/TableUnitCard/TableUnitCard.i18n";
import { TagTranslations } from "@/components/Tag/Tag.i18n";
import { UnitCardTranslations } from "@/components/UnitCard/UnitCard.i18n";
import { SchemeHeaderI18n } from "@/components/UnitHeader/UnitHeader.i18n";
import { UnsavedChangesModalTranslations } from "@/components/UnsavedChangesModal/UnsavedChangesModal.i18n";
import { ViewCustomUnitI18n } from "@/components/ViewCustomUnitModal/ViewCustomUnitModal.i18n";

import { CurriculumListPageTranslations } from "@/pages/CurriculumList/CurriculumList.i18n";
import { EditSubjectPlanTranslations } from "@/pages/EditSubjectPlan/EditSubjectPlan.i18n";
import { ExploreSchemeTranslations } from "@/pages/ExploreScheme/ExploreScheme.i18n";
import { LearningSequenceTranslations } from "@/pages/LearningSequence/LearningSequence.i18n";
import { SchemeOverviewPageTranslations } from "@/pages/SchemeOverview/SchemeOverview.i18n";
import { SubjectListTranslations } from "@/pages/SubjectList/SubjectList.i18n";
import { SubjectPlanPageTranslations } from "@/pages/SubjectPlanOverview/SubjectPlanOverview.i18n";

import { PlanitLinkInfoI18n } from "@/utils/SubjectHelper/utils/getPlanitLinkInfo/getPlanitLinkInfo.i18n";

import { CommonTranslations } from "./common/common.i18n";

// As we build more components, we can add them to this file to merge all the translations together and maintain type inferance for the translation object.
export const Translations = merge(
  AppHeaderTranslations,
  CommonTranslations,
  ConflictResolutionModalTranslations,
  CurriculumListPageTranslations,
  DuplicateCurriculumModalTranslations,
  EditCurriculumModalTranslations,
  EditSubjectPlanTranslations,
  ExploreSchemeHeaderI18n,
  ExploreSubjectUnitCardTranslations,
  ExploreSchemeTranslations,
  GenericCurriculumFormTranslations,
  GenericErrorModalI18n,
  GenericErrorTranslations,
  LearningSequenceTranslations,
  ManageAdaptationNotesModalI18n,
  MultiSchoolAccountModalI18n,
  NewCurriculumModalTranslations,
  NewUnitCardI18n,
  PlanitLinkInfoI18n,
  PlannerSettingsModalTranslations,
  RemoveUnitModalI18n,
  SchemeHeaderI18n,
  SessionExpiredModalI18n,
  SchemeOverviewPageTranslations,
  SidebarNavigationTranslations,
  SignedOutModalI18n,
  SubjectCardTranslations,
  SubjectListTranslations,
  SubjectPlanPageTranslations,
  SubjectPlanHeaderI18n,
  TableUnitCardI18n,
  TagTranslations,
  UnitCardTranslations,
  UnsavedChangesModalTranslations,
  ViewCustomUnitI18n
);
